import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TranslateService }       from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { LoanCarService }  from './loan-car.service';
import { SessionService }  from '../sessions/session.service';
import { Table }                 from '../table/types/table';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { TableRowEvent }        from '../table/types/table-row-event';
import { TableService }    from '../table/table.service';

@Component({
  selector   : 'wor-loan-vehicles',
  template: require('./loan-car-schedule.vehicles.component.html')
})
export class LoanVehiclesComponent implements OnInit, AfterViewInit {
  @Input() loan_vehicles: any;

  filtering: any;
  regoLabel: string;
  tableSettings: Table;
  private tableCacheKey = 'loanVehicles';

  constructor (
    private apiService      : ApiService,
    public  loanCarService  : LoanCarService,
    private sessionService  : SessionService,
    private tableService    : TableService,
    private changeDetectorRef: ChangeDetectorRef,
    private translateService: TranslateService
  ) {}

  ngOnInit () {
    const company    = this.sessionService.company();
    this.regoLabel   = company.company_variable_fields?.plate_number_name || this.sessionService.countrySettings().rego_label;

    this.filtering = this.tableService.setFiltersFromCache(this.tableCacheKey, { value: '' });

    this.tableSettings = {
      cache: { enabled: true, key: this.tableCacheKey },
      columns: [
        { classes: 'all-caps', field: 'plate_number', header: { text: this.regoLabel } },
        { field: 'make',   header: { text: this.translateService.instant('VEHICLE_SPACE.MAKE') } },
        { field: 'model',  header: { text: this.translateService.instant('VEHICLE_SPACE.MODEL') } },
        { field: 'colour', header: { text: this.translateService.instant('VEHICLE_SPACE.COLOUR') } }
      ],
      empty     : { text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_LOAN_VEHICLES_FOUND') },
      pagination: {
        enabled: true,
        pageSize: this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 10,
        pageSizes: [10, 25, 50],
        queryCount: () => this.apiService.get('/filters/count', [this.filtering.value || '*', 'loan_vehicles', false])
      },
      rows   : { highlight: { enabled: true } },
      broadcast: 'filterLoanVehicles',
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, { direction: 'asc', field: 'plate_number' })
    };
  }

  ngAfterViewInit () {
    const interval = setInterval(() => {
      if (typeof window['filterLoanVehicles'] === 'function') {

        clearInterval(interval);

        this.onFiltersChanged();

      }
    }, 100);
  }

  onFiltersChanged () : void {


    window['filterLoanVehicles'](this.filtering);


  }

  getLoanVehicles ( params : TableQueryParameters ) : Promise<any> {
    return this.apiService.stream('/filters', [
      this.filtering.value || '*', 'loan_vehicles', params.offset, params.pageSize, params.field, params.direction, false
    ]).then(vehicles => {
      this.loan_vehicles = vehicles;
      this.changeDetectorRef.detectChanges();

      return vehicles;
    });
  }

  onRowDoubleClick ( event : TableRowEvent ) : void {


    this.loanCarService.manageLoanVehicle(event.row.id);


    };


  }
